document.addEventListener('DOMContentLoaded', function () {
  initHappyCustomersCarousels();
});

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    initHappyCustomersCarousels(event.target);
  });
}

function initHappyCustomersCarousels(scope) {
  var root = scope || document;
  var sections = root.querySelectorAll('.hcrc-section');

  sections.forEach(function (section) {
    if (section.dataset.hcrcInitialized === 'true') return;

    var sectionId = section.id.replace('hcrc-section-', '');
    var swiperEl = section.querySelector('#hcrc-swiper-' + sectionId);
    if (!swiperEl || typeof Swiper === 'undefined') return;

    var prevBtn = section.querySelector('#hcrc-prev-' + sectionId);
    var nextBtn = section.querySelector('#hcrc-next-' + sectionId);
    var currentEl = section.querySelector('#hcrc-current-' + sectionId);

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: false,
      watchOverflow: true,
      a11y: true,
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 24
        }
      },
      on: {
        slideChange: function () {
          updateCounter(this);
        },
        init: function () {
          updateCounter(this);
        }
      }
    });

    function updateCounter(instance) {
      if (!currentEl) return;
      var current = instance.activeIndex + 1;
      var maxIndex = instance.slides.length - instance.params.slidesPerView + 1;
      if (current > maxIndex && maxIndex > 0) current = maxIndex;
      currentEl.textContent = current;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        swiper.slidePrev();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        swiper.slideNext();
      });
    }

    swiper.on('reachBeginning', function () {
      if (prevBtn) prevBtn.classList.add('swiper-button-disabled');
    });

    swiper.on('reachEnd', function () {
      if (nextBtn) nextBtn.classList.add('swiper-button-disabled');
    });

    swiper.on('fromEdge', function () {
      if (prevBtn) prevBtn.classList.remove('swiper-button-disabled');
      if (nextBtn) nextBtn.classList.remove('swiper-button-disabled');
    });

    section.dataset.hcrcInitialized = 'true';
  });
}
